import { call, takeLatest, put } from 'redux-saga/effects';
import makeSagaRequest from 'app/shared/sagas/makeSagaRequest';

// Models
import { SessionActionTypes } from 'app/modules/session/models';

// API
import { emailTokenExchange as emailTokenExchangeEndpoint } from 'app/shared/api/session';

// Action
import {
  emailTokenExchange as emailTokenExchangeAction,
  startSession,
} from 'app/modules/session/actions';

// Utils
import routes from 'app/shared/utils/routes';
import { history } from 'app/store/browserHistory';
import { LocalStorageKeys } from 'app/shared/constants/localStorage';

const rootAction = SessionActionTypes.EMAIL_TOKEN_EXCHANGE;
function* emailTokenExchange({
  payload,
}: ReturnType<typeof emailTokenExchangeAction>) {
  const { token, auth } = payload;

  yield call(makeSagaRequest, {
    rootAction,
    request: call(emailTokenExchangeEndpoint, { token }),
    success: function* onSuccess(result) {
      if (auth) {
        auth.loginSuccess(result);
        yield put(startSession(auth));

        // Restore original route if it was saved, otherwise go to home
        const originalRoute = localStorage.getItem(
          LocalStorageKeys.MAGIC_LINK_ORIGINAL_ROUTE,
        );
        if (originalRoute) {
          localStorage.removeItem(LocalStorageKeys.MAGIC_LINK_ORIGINAL_ROUTE);
          history.push(originalRoute);
        } else {
          history.push(routes.lumos.home);
        }
      }
    },
  });
}

export default function* emailTokenExchangeSaga() {
  yield takeLatest(rootAction, emailTokenExchange);
}
